// Full cart page (/cart): plain native <form action="/cart" method="post">
// with updates[key] inputs — works with or without JS. This component only
// adds two conveniences: auto-submit when a quantity stepper changes, and a
// remove button that zeroes its line's quantity before submitting.
class CartPageForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');

    this.addEventListener('quantity:change', () => this.form.requestSubmit());

    this.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('[data-cart-page-remove]');
      if (!removeBtn) return;
      const input = removeBtn.closest('li').querySelector('input[type="number"]');
      if (input) {
        input.value = 0;
        this.form.requestSubmit();
      }
    });
  }
}

if (!customElements.get('cart-page-form')) {
  customElements.define('cart-page-form', CartPageForm);
}
